module.exports = __webpack_public_path__ + "img/pd4.a2fae795.jpg";